import { useState } from "react";

export default function AdminLogin({ onAuth }) {
  const [password, setPassword] = useState("");
  const [error, setError]       = useState(false);
  const [shake, setShake]       = useState(false);

  function attempt() {
    if (password === process.env.REACT_APP_ADMIN_PASSWORD) {
      sessionStorage.setItem("ap_admin", "1");
      onAuth();
    } else {
      setError(true);
      setShake(true);
      setPassword("");
      setTimeout(() => setShake(false), 500);
    }
  }

  return (
    <div style={{ maxWidth: 380, margin: "80px auto", padding: "0 24px" }}>
      <div className="card" style={{ padding: "36px 28px", animation: shake ? "shake 0.4s ease" : "none" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img src="/logo-ap.png" alt="AnchorPoint" style={{ height: 48, marginBottom: 16 }} />
          <p style={{ fontSize: 11, letterSpacing: 3, textTransform: "uppercase", color: "#444" }}>
            Panel de administración
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <input
            className="input"
            type="password"
            placeholder="Contraseña"
            value={password}
            autoFocus
            onChange={e => { setPassword(e.target.value); setError(false); }}
            onKeyDown={e => e.key === "Enter" && attempt()}
            style={{ borderColor: error ? "#cc2200" : undefined }}
          />
          {error && <p style={{ fontSize: 12, color: "#cc2200", margin: 0 }}>Contraseña incorrecta.</p>}
          <button className="btn-primary" onClick={attempt} style={{ padding: 12 }}>
            Entrar
          </button>
        </div>
      </div>
    </div>
  );
}
